import { urlBaseAccreditation } from "../../config";
import axiosInstance from "../../../services/config/axiosinstance";

export default async function getAdminTokenApi(
  eventId = '',
) {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseAccreditation}/user/getMiceToken?eventId=${eventId}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data?.data;
  } catch (error) {
    console.log('Error getAdminTokenApi', error);
    throw error;
  }
}
